export const HEADER_HEIGHT_DESKTOP = 80;
export const HEADER_HEIGHT_MOBILE = 60;
export const MAX_TABLET_BREAKPOINT = '1090px';
export const PRIME_URL = 'https://prime.cex.io/';
export const ID_FAQ = 'faq';
export const ID_APPROACH = 'approach';
export const DEFAULT_PRECISION = 8;
